import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthFacade } from '../facades/auth.facade';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';

export const guestGuard: CanActivateFn = () => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  return toObservable(authFacade.isLoading).pipe(
    filter(isLoading => !isLoading),
    map(() => {
      if (authFacade.isAuthenticated()) {
        if (authFacade.isIncompleteStudent()) {
          return router.createUrlTree(['/onboarding']);
        }
        if (authFacade.isSuperAdmin()) {
          return router.createUrlTree(['/admin']);
        }
        if (authFacade.isTeacher()) {
          return router.createUrlTree(['/teacher/home']);
        }
        return router.createUrlTree(['/student/home']);
      }
      return true;
    })
  );
};
